import React from 'react';
import { observer } from 'mobx-react';

import { isFrontendOutdated } from 'helpers/utils';

import DefaultFallback from './DefaultFallback';

export const logError = (error: Error, info?: object) => {
  if (process.env.NODE_ENV === 'production') {
    window.Sentry.captureException(error, { extra: info });
  }
};

type FallbackProps = {
  removeError: () => void;
  isOutdated: boolean;
};

type Props = {
  children: React.ReactNode;
  fallbackComponent?: React.ComponentType<FallbackProps>;
};

type State = {
  hasError: boolean;
};

@observer
class ErrorBoundary extends React.Component<Props, State> {
  state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
    });
    logError(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallbackComponent &&
        this.props.fallbackComponent({
          removeError: () => this.setState({ hasError: false }),
          isOutdated: isFrontendOutdated(),
        })
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.defaultProps = {
  fallbackComponent: DefaultFallback,
};

export default ErrorBoundary;
